<template>
  <v-card class="card_dialog" color="background">
    <v-row
      class="ma-0"
      justify="space-between"
      style="align-items: self-end !important"
    >
      <v-col cols="10">
        <span :class="xs ? 'textDashboard' : 'subtitleDashboard'">
          {{ t("title.graphTitle") }} {{ name }}</span
        >
      </v-col>
      <v-col cols="1">
        <v-btn
          icon="mdi-close"
          variant="plain"
          @click="$emit('dialog', false)"
        ></v-btn>
      </v-col>
    </v-row>
    <v-divider class="mt-7"></v-divider>
    <v-sheet color="transparent">
      <PrimaryGraphs
        :ip="ip"
        :typesel="typeSel"
        :name="name"
        :status="status"
        :model="model"
      />
      <pmpAp :ip="ip" :title="'typeValue'" />
      <statusLog :ip="ip" :typesel="typeSel" :name="name" />
      <RAOS
        v-if="projectName === 'SmartLinkRAOS'"
        :ip="ip"
        :title="'typeValue'"
      />
      <PmpSm
        v-if="typeSel === STRING_GENERAL.quality_lap || typeSel === TYPES.pmpsm"
        :ip="ip"
        :title="'typeValue'"
      />
      <instameshGraphsVue
        v-if="typeSel !== TYPES.pmpap && typeSel !== TYPES.pmpsm"
        :ip="ip"
        :typeitem="typeSel"
      />
    </v-sheet>
  </v-card>
</template>

<script setup lang="ts">
import { computed } from "vue";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from "vuetify";
const { xs } = useDisplay();

/********************************
 ********** COMPONENTS **********
 *******************************/
import instameshGraphsVue from "@/components/SmartLink/dialog/instameshGraphs.vue";
import PrimaryGraphs from "./primaryGraphs.vue";
import statusLog from "./status-log.vue";
import pmpAp from "./pmp-ap.vue";
import PmpSm from "./pmp-sm.vue";
import RAOS from "@/components/RAOS/Components/Dialogs/RAOS.vue";

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from "vue-i18n";
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
import { STRING_GENERAL, TYPES } from "@/constants/labels";

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from "vuex";
const store = useStore();

const projectName = computed(() => store.state.projectName);

defineProps({
  marca: { type: String },
  status: { type: String },
  model: { type: String },
  ip: { type: String, required: true },
  typeSel: { type: String, required: true },
  name: { type: String, required: true },
});
</script>
